import { create } from 'zustand';
import { outdatedAgentsCheckManager } from '@/utils/outdatedAgentsCheck';

interface OutdatedAgentsState {
  // State
  outdatedCount: number;
  isChecking: boolean;
  lastCheckedAt: number | null;

  // Actions
  setOutdatedCount: (count: number) => void;
  setIsChecking: (checking: boolean) => void;

  // Lifecycle
  startMonitoring: () => void;
  stopMonitoring: () => void;
  forceCheck: () => void;
}

export const useOutdatedAgentsStore = create<OutdatedAgentsState>((set) => ({
  // Initial state
  outdatedCount: 0,
  isChecking: false,
  lastCheckedAt: null,

  // Actions
  setOutdatedCount: (count: number) => {
    set({
      outdatedCount: count,
      lastCheckedAt: Date.now(),
      isChecking: false,
    });
  },

  setIsChecking: (checking: boolean) => {
    set({ isChecking: checking });
  },

  // Lifecycle methods
  startMonitoring: () => {
    console.log('[OutdatedAgentsStore] Starting monitoring');
    set({ isChecking: true });

    // Start the check manager with our callback
    outdatedAgentsCheckManager.start((count) => {
      set({
        outdatedCount: count,
        lastCheckedAt: Date.now(),
        isChecking: false,
      });
    });
  },

  stopMonitoring: () => {
    console.log('[OutdatedAgentsStore] Stopping monitoring');
    outdatedAgentsCheckManager.stop();
    set({
      outdatedCount: 0,
      isChecking: false,
      lastCheckedAt: null,
    });
  },

  forceCheck: () => {
    console.log('[OutdatedAgentsStore] Force check triggered');
    set({ isChecking: true });
    outdatedAgentsCheckManager.forceCheck();
  },
}));
